// extracted by mini-css-extract-plugin
export var actions = "_gb-d";
export var benefitCard = "_gb-a";
export var benefitIcon = "_gb-b";
export var benefitLabel = "_gb-c";
export var benefits = "_gb-9";
export var bodyText = "_gb-8";
export var closeButton = "_gb-2";
export var content = "_gb-3";
export var eyebrow = "_gb-4";
export var heading = "_gb-5";
export var image = "_gb-f";
export var imagePanel = "_gb-e";
export var modal = "_gb-0";
export var shell = "_gb-1";
export var title = "_gb-6";
export var titleOffer = "_gb-7";